import type { EmbarcacaoComercialField } from "@/modules/embarcacoes";
import { formatDetailDate, formatDetailDateOrText } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const COMERCIAL_ID = "comercial";
export const COMERCIAL_TITLE = "Comercial";
export const COMERCIAL_TEST_ID = "embarcacao-comercial";
export const COMERCIAL_LOADING_MESSAGE = "Carregando as informações Comerciais da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const COMERCIAL_EMPTY_STATE = {
  title: "Nenhuma informação comercial disponível",
  description:
    "Assim que houver dados comerciais para esta embarcação, eles aparecerão nesta seção.",
};

/**
 * Os 5 campos da seção, na ordem e nas colunas do protótipo (AC1/AC3). O grid
 * os distribui em duas colunas, preenchendo a linha da esquerda para a direita:
 * Cliente Atual com Observações, Início com Fim do Contrato e a Extensão do
 * Contrato sozinha na última linha.
 */
export const COMERCIAL_FIELDS: readonly DetailFieldDefinition<EmbarcacaoComercialField>[] = [
  { key: "clienteAtual", label: "Cliente Atual" },
  { key: "observacoes", label: "Observações" },
  { key: "inicioContrato", label: "Início de Contrato", format: formatDetailDate },
  { key: "fimContrato", label: "Fim do Contrato", format: formatDetailDate },
  // Data no contrato, mas guardada na base conforme o valor disponível.
  { key: "extensaoContrato", label: "Extensão do Contrato", format: formatDetailDateOrText },
];
